import React from "react";
const HeartLargeIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={62}
      height={62}
      viewBox="0 0 62 62"
      xmlns="http://www.w3.org/2000/svg"
      fill="var(--color-theme-600)"
      ref={svgRef}
      {...props}
    >
      <g fillRule="evenodd">
        <path d="M45.5 0C54.613 0 62 7.387 62 16.5c0 3.537-1.113 6.814-3.008 9.5H59L31 62 3 26a16.473 16.473 0 01-3-9.5C0 7.387 7.387 0 16.5 0 22.759 0 28.204 3.485 31 8.62 33.796 3.485 39.241 0 45.5 0z" />
        <path d="M16.5 6c1.61 0 3.134.362 4.498 1.01-7.61.258-13.73 6.379-13.99 13.987A10.466 10.466 0 016 16.5C6 10.701 10.701 6 16.5 6z" />
        <path d="M45.5 0C54.613 0 62 7.387 62 16.5c0 3.537-1.113 6.814-3.008 9.5H59L31 62 3 26l-.034-.05-.05-.084-.025-.06c-.01-.041.006-.058.048-.05l.064.022a.797.797 0 01.041.019l.162.093.218.145.38.276.48.369.742.592 1.098.903 1.818 1.53 2.528 2.169 1.625 1.408 3.723 3.254 6.272 5.535 5.794 5.15 2.886 2.574 20.665-26.57A14.082 14.082 0 0054 15.106C54 7.42 47.855 1.17 40.21 1.003L39.83 1c1.768-.647 3.678-1 5.671-1z" />
        <path
          d="M45.5 1.5c4.142 0 7.892 1.679 10.607 4.393A14.953 14.953 0 0160.5 16.5a14.93 14.93 0 01-2.714 8.608h0L31 59.557 4.207 25.109A14.978 14.978 0 011.5 16.5c0-4.142 1.679-7.892 4.393-10.607A14.953 14.953 0 0116.5 1.5c2.795 0 5.413.764 7.653 2.096A15.05 15.05 0 0131 12.634a15.04 15.04 0 016.846-9.038A14.927 14.927 0 0145.5 1.5h0z"
          stroke="#000"
          strokeWidth={3}
        />
      </g>
    </svg>
  )
);
HeartLargeIcon.displayName = "HeartLargeIcon";
export default HeartLargeIcon;
